var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length)?_c('ul',{staticClass:"cordel-errors"},_vm._l((_vm.items),function(error){return _c('li',{key:error},[_vm._v("\n    "+_vm._s(error)+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }